/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('alpinejs');
require('./main/bootstrap');
require('select2');
require('owl.carousel');
require('slick-carousel');
require('nouislider');
require('./main/main');
require('./main/backend');
require('./main/pdf-viewer');
require('./main/commerce-lazy');

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.splide.main').forEach(function (el) {

        var splide = new Splide(el, {
            type      : 'slide',
            autoplay  : false,
            width     : '100%',
            arrows    : true,
            pagination: false,
            rewind    : true,
            pauseOnHover: true,

            video: {
                autoplay: true,
                loop: false,
                mute: true,
                disableOverlayUI: true,
                hideControls: true,
                playerOptions: {
                    htmlVideo: {
                        autoplay   : true,
                        playsInline: true,
                        preload    : 'metadata',
                    },
                },
            },
        });

        var defaultInterval = parseInt(el.getAttribute('interval')); // ms for non-video slides
        var timerId = null;

        function clearTimer() {
            if (timerId) {
                clearTimeout(timerId);
                timerId = null;
            }
        }

        function scheduleForIndex(index) {
            clearTimer();

            var Slides = splide.Components.Slides;
            var SlideObj = Slides.getAt(index);
            if (!SlideObj) return;

            var slideEl = SlideObj.slide;

            // Splide Video extension adds this class to slides with video
            var hasVideo =
                slideEl.classList.contains('splide__slide--has-video') ||
                slideEl.hasAttribute('data-splide-html-video') ||
                slideEl.hasAttribute('data-splide-youtube') ||
                slideEl.hasAttribute('data-splide-vimeo');

            if (hasVideo) {
                // Do nothing here: we wait for `video:ended`
                return;
            }

            // Normal slide: fake autoplay with a timeout
            timerId = setTimeout(function () {
                splide.go('>');
            }, defaultInterval);
        }

        // When active slide changes (e.g. arrow, drag, programmatic)
        splide.on('active', function (Slide) {
            scheduleForIndex(Slide.index);
        });

        // When a video ends, move to next slide
        splide.on('video:ended', function (player) {
            clearTimer();
            splide.go('>');
        });

        splide.on('mounted', function () {
            // Kick off autoplay logic for the initial slide
            scheduleForIndex(splide.index);

            el.querySelectorAll('.splide__video').forEach(function(videoContainer) {
                const slide = videoContainer.closest('.splide__slide');
                const bannerMediaContainer = slide.querySelector('.banner-media');
                if (bannerMediaContainer) {
                    bannerMediaContainer.appendChild(videoContainer);
                    splide.refresh();
                }
            });
        });

        splide.mount(window.splide.Extensions);
    });
});